export default [
    "Afganistán",
    "Albania",
    "Argelia",
    "Andorra",
    "Angola",
    "Antigua y Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaiyán",
    "Bahamas",
    "Baréin",
    "Bangladés",
    "Barbados",
    "Bielorrusia",
    "Bélgica",
    "Belice",
    "Benín",
    "Bután",
    "Bolivia",
    "Bosnia y Herzegovina",
    "Botsuana",
    "Brasil",
    "Brunéi",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Camboya",
    "Camerún",
    "Canadá",
    "República Centroafricana",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoras",
    "República del Congo",
    "Costa Rica",
    "Croacia",
    "Cuba",
    "Chipre",
    "Chequia",
    "Dinamarca",
    "Yibuti",
    "Dominica",
    "República Dominicana",
    "Ecuador",
    "Egipto",
    "El Salvador",
    "Guinea Ecuatorial",
    "Eritrea",
    "Estonia",
    "Esuatini",
    "Etiopía",
    "Fiyi",
    "Finlandia",
    "Francia",
    "Gabón",
    "Gambia",
    "Georgia",
    "Alemania",
    "Ghana",
    "Grecia",
    "Granada",
    "Guatemala",
    "Guinea",
    "Guinea-Bisáu",
    "Guyana",
    "Haití",
    "Santa Sede",
    "Honduras",
    "Hungría",
    "Islandia",
    "India",
    "Indonesia",
    "Irán",
    "Irak",
    "Irlanda",
    "Israel",
    "Italia",
    "Jamaica",
    "Japón",
    "Jordania",
    "Kazajistán",
    "Kenia",
    "Kiribati",
    "Kuwait",
    "Kirguistán",
    "Laos",
    "Letonia",
    "Líbano",
    "Lesoto",
    "Liberia",
    "Libia",
    "Liechtenstein",
    "Lituania",
    "Luxemburgo",
    "Madagascar",
    "Malaui",
    "Malasia",
    "Maldivas",
    "Malí",
    "Malta",
    "Islas Marshall",
    "Mauritania",
    "Mauricio",
    "México",
    "Micronesia",
    "Moldavia",
    "Mónaco",
    "Mongolia",
    "Montenegro",
    "Marruecos",
    "Mozambique",
    "Birmania (Myanmar)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Países Bajos",
    "Nueva Zelanda",
    "Nicaragua",
    "Níger",
    "Nigeria",
    "Corea del Norte",
    "Macedonia del Norte",
    "Noruega",
    "Omán",
    "Pakistán",
    "Palaos",
    "Estado de Palestina",
    "Panamá",
    "Papúa Nueva Guinea",
    "Paraguay",
    "Perú",
    "Filipinas",
    "Polonia",
    "Portugal",
    "Catar",
    "Rumania",
    "Rusia",
    "Ruanda",
    "San Cristóbal y Nieves",
    "Santa Lucía",
    "San Vicente y las Granadinas",
    "Samoa",
    "San Marino",
    "Santo Tomé y Príncipe",
    "Arabia Saudita",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leona",
    "Singapur",
    "Eslovaquia",
    "Eslovenia",
    "Islas Salomón",
    "Somalia",
    "Sudáfrica",
    "Corea del Sur",
    "Sudán del Sur",
    "España",
    "Sri Lanka",
    "Sudán",
    "Surinam",
    "Suecia",
    "Suiza",
    "Siria",
    "Tayikistán",
    "Tanzania",
    "Tailandia",
    "Timor Oriental",
    "Togo",
    "Tonga",
    "Trinidad y Tobago",
    "Túnez",
    "Turquía",
    "Turkmenistán",
    "Tuvalu",
    "Uganda",
    "Ucrania",
    "Emiratos Árabes Unidos",
    "Reino Unido",
    "Estados Unidos de América",
    "Uruguay",
    "Uzbekistán",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabue"
  ];
  